/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_LeadInputs */



/**
* | output |
* | --- |
* | "From SIRE 2.0 vetting to OCIMF management-system audits, carried out by accredited Master Mariners and Chief Engineers." |
*
* @param {Services_LeadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_lead = /** @type {((inputs?: Services_LeadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_LeadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("从 SIRE 2.0 审查到 OCIMF 管理体系审核，均由认证船长和轮机长执行。")
	return /** @type {LocalizedString} */ ("From SIRE 2.0 vetting to OCIMF management-system audits, carried out by accredited Master Mariners and Chief Engineers.")
});